import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}


export default {
 argroup() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/arinv/postgroup");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
aradjustgroup() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/aradjust/aradjustgroup");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal','tgl1', 'tgl2','status', 'nomor', 'invoiceno','customer', 'kodeacc', 'namaacc','artype'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/aradjust${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
currency() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/currency/cbo");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
detail(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get(`aradjust/detail/${obj.aradjuttKey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
save(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.post("aradjust", obj);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.delete(`aradjust/${obj.aradjuttKey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
potongan() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/aradjust/potongan");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
posting(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.put(`aradjust/posting/${obj.aradjuttKey}`);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
postingUndo(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.put(`aradjust/unposting/${obj.aradjuttKey}`);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
printjv(obj = {}) {
    return new Promise(async (resolve, reject) => {
        let url;
        let str = '';
        try {
            str = '?key=' + encodeURIComponent(obj.aradjuttKey);
            url = `/aradjust/printjv`;

            url += str;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
exportXls(obj = {}) {
    const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'invoiceno', 'customer', 'kodeacc', 'namaacc', 'artype'];

    let str = '';
    for (const key in obj) {
        if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
        }
    }

    axios({
        url: `/aradjust/exportxls${str}`,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'aradjust.xlsx');
        document.body.appendChild(link);
        link.click();
        // window.location.assign(url);
    });

}
};